import { Component } from '@theme/component';

const MAX_FILE_SIZE = 10 * 1024 * 1024;

/**
 * A custom element that reveals a logo-upload + customization-text pair
 * of fields on customizable products, submitted as cart line item properties.
 */
class ProductCustomize extends Component {
  handleToggle = (event) => {
    const fields = this.querySelector('[data-customize-fields]');
    if (!(event.target instanceof HTMLInputElement) || !fields) return;

    const inputs = fields.querySelectorAll('input, textarea');

    if (event.target.checked) {
      fields.hidden = false;
      inputs.forEach((el) => el.removeAttribute('disabled'));
    } else {
      fields.hidden = true;
      inputs.forEach((el) => {
        if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) el.value = '';
        el.setAttribute('disabled', 'disabled');
      });

      const error = this.querySelector('[data-customize-file-error]');
      if (error instanceof HTMLElement) error.hidden = true;

      const counter = this.querySelector('[data-customize-counter]');
      if (counter) counter.textContent = '0/100';
    }
  };

  handleFileChange = (event) => {
    const input = event.target;
    const error = this.querySelector('[data-customize-file-error]');
    if (!(input instanceof HTMLInputElement) || !(error instanceof HTMLElement)) return;

    const file = input.files?.[0];
    if (file && file.size > MAX_FILE_SIZE) {
      error.textContent = 'File is too large. Maximum size is 10MB.';
      error.hidden = false;
      input.value = '';
    } else {
      error.hidden = true;
    }
  };

  handleTextInput = (event) => {
    const input = event.target;
    const counter = this.querySelector('[data-customize-counter]');
    if (!(input instanceof HTMLTextAreaElement) || !counter) return;
    counter.textContent = `${input.value.length}/100`;
  };
}

if (!customElements.get('product-customize')) {
  customElements.define('product-customize', ProductCustomize);
}
